export const normalizeInspectorMessages = (messages) => {
  if (Array.isArray(messages)) return messages;
  if (!messages) return [];

  if (typeof messages === 'string') {
    const trimmed = messages.trim();
    if (!trimmed) return [];
    try {
      return normalizeInspectorMessages(JSON.parse(trimmed));
    } catch {
      return [{ role: 'user', content: trimmed }];
    }
  }

  if (typeof messages !== 'object') return [];
  if (Array.isArray(messages.messages)) return messages.messages;
  if (Array.isArray(messages.input_messages)) return messages.input_messages;
  if (Array.isArray(messages.contents)) {
    return messages.contents.map(message => ({
      role: message?.role === 'model' ? 'assistant' : message?.role,
      content: message?.parts || message?.content || message?.text || '',
    }));
  }
  if (messages.role || messages.content || messages.text) return [messages];
  return [];
};
